import { CuentaContableEmpresaReadingDtoProps } from "api/DTOs/CuentaContableEmpresaReadingDto"

export const TaxAccount = ({
  nombre,
  numero,
}: CuentaContableEmpresaReadingDtoProps) => {
  return (
    <div>
      <span className='tw-font-bold tw-pr-1'>{numero}</span>
      {nombre}
    </div>
  )
}
